(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pv-technology"]) return;
  try {
    
if (!customElements.get('pv-technology')) {
  customElements.define('pv-technology', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (el, type, fn, options = {}) => el.addEventListener(type, fn, {...options, signal});
      this.querySelectorAll('[data-comparison]').forEach(box => {
        const input = box.querySelector('input');
        const update = () => {
          box.style.setProperty('--position', input.value + '%');
          input.setAttribute('aria-valuetext', input.value + '% original view');
        };
        on(input, 'input', update); update();
      });
      this.querySelectorAll('[data-material-model]').forEach(section => {
        let model = section.dataset.materialModel, view = 'front';
        const image = section.querySelector('.material-main-image');
        const render = () => {
          const button = [...section.querySelectorAll('[data-frame-model]')].find(b => b.dataset.frameModel === model);
          if (!button) return;
          image.src = button.dataset[view];
          image.alt = model.toUpperCase() + ' actual product photograph, ' + (view === 'front' ? 'front view' : 'side and temple view');
          section.querySelector('.material-model-name').textContent = model.toUpperCase();
          section.querySelector('.material-link-model').textContent = model.toUpperCase();
          section.querySelector('.material-shop').href = button.dataset.productUrl;
          section.querySelectorAll('[data-frame-model]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.frameModel === model)));
          section.querySelectorAll('[data-frame-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.frameView === view)));
        };
        section.querySelectorAll('[data-frame-model]').forEach(b => on(b, 'click', () => {model = b.dataset.frameModel;render();}));
        section.querySelectorAll('[data-frame-view]').forEach(b => on(b, 'click', () => {view = b.dataset.frameView;render();}));
        render();
      });
      const nav = this.querySelector('.section-nav');
      const findTarget = hash => {
        let id;try{id=decodeURIComponent(hash.replace(/^#/,''));}catch{return null;}
        return [...this.querySelectorAll('[id]')].find(el=>el.id===id)||null;
      };
      const links = [...this.querySelectorAll('.section-nav a')].filter(a=>{
        const exists=!!findTarget(a.hash);a.hidden=!exists;return exists;
      });
      const sections = links.map(a => findTarget(a.hash));
      const headers=[...document.querySelectorAll('#SiteHeader, sticky-header, .header-wrapper, .shopify-section-header, [data-pv-header]')];
      const measure = () => {
        let bottom = 0;
        headers.forEach(header => {
          let el = header, sticky = false;
          while (el && el !== document.body) {
            if (['sticky', 'fixed'].includes(getComputedStyle(el).position)) sticky = true;
            el = el.parentElement;
          }
          const rect = header.getBoundingClientRect();
          const visible=getComputedStyle(header).visibility!=='hidden';
          if (sticky && visible && rect.top <= 1 && rect.bottom > 0 && rect.height > 0) bottom = Math.max(bottom, rect.bottom);
        });
        bottom += Number(this.dataset.headerOffset) || 0;
        this.style.setProperty('--store-header-height', bottom + 'px');
        this.style.setProperty('--section-nav-height', (nav?.offsetHeight || 0) + 'px');
        const threshold = bottom + (nav?.offsetHeight || 0) + 20;
        let active = sections[0]?.id;
        sections.forEach(s => {if (s.getBoundingClientRect().top <= threshold) active = s.id;});
        links.forEach(a => {const selected = a.hash === '#' + active;a.classList.toggle('active', selected);if(selected)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
      };
      const schedule = () => {if (!this.frame) this.frame = requestAnimationFrame(() => {this.frame = null;measure();});};
      on(window, 'scroll', schedule, {passive:true}); on(window, 'resize', schedule);
      on(document, 'shopify:block:select', event => {if(this.contains(event.target))event.target.scrollIntoView({block:'start'});});
      this.observer = new ResizeObserver(schedule);this.observer.observe(this);
      headers.forEach(header=>this.observer.observe(header));
      const navigate=(hash,focus=false,smooth=false)=>{
        let target=findTarget(hash);if(!target)return;
        if(target.classList.contains('pv-anchor'))target=findTarget('#pv-tech-'+target.id)||target;
        measure();target.scrollIntoView({behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant',block:'start'});
        if(focus){if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');target.focus({preventScroll:true});}
      };
      this.querySelectorAll('a[href^="#"]').forEach(a => on(a, 'click', event => {
        if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        const target = findTarget(a.hash);if(!target)return;
        event.preventDefault();if(location.hash!==a.hash)history.pushState(null,'',a.hash);
        navigate(a.hash,true,true);
      }));
      on(window,'hashchange',()=>navigate(location.hash));
      this.setAttribute('data-ready','');
      measure();
      if(location.hash)this.hashFrame=requestAnimationFrame(()=>navigate(location.hash));
    }
    disconnectedCallback() {
      this.controller?.abort();this.controller=null;this.observer?.disconnect();cancelAnimationFrame(this.frame);cancelAnimationFrame(this.hashFrame);this.frame=null;this.removeAttribute('data-ready');
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
